<script setup lang="ts">
import { numHelper } from '@/utils/numHelper.ts'
import { computed } from 'vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const value = computed(() => {
  return (typeof props.data === 'string' || typeof props.data === 'number') ? props.data : 0
})

const fixedNumber = computed(() => {
  return props.cellConfig?.config?.fixedNumber || 0
})

const decimalSp = computed(() => {
  return props.cellConfig?.config?.decimalSp || ','
})

const thousandSp = computed(() => {
  return props.cellConfig?.config?.thousandSp || '.'
})
</script>

<template>
  <div class="table-cell justify-end">
<!--    {{fixedNumber}} {{decimalSp}} {{thousandSp}}-->
    <span class="value">{{value > 0 ? numHelper(value).format(fixedNumber, decimalSp, thousandSp) : '-'}}</span>
  </div>
</template>

<style scoped>

</style>
